<template>
    <div id="logout-popup" class="flex justify-center items-center">
        <div class="backdrop"></div>
        <div class="popup-content">
            <div class="popup-header flex justify-between items-center">
                <h1>{{ $t('feide_logout_header') }}</h1>
                <div @click="closePopup" class="close-button flex justify-center items-center cursor-pointer">
                    <i class="fas fa-times"></i>
                </div>
            </div>
            <div class="popup-body">
                <div class="flex justify-center items-center">
                    <div class="warning-icon-box flex justify-center items-center">
                        <i class="fas fa-exclamation"></i>
                    </div>
                </div>
                <p class="text-center font-size-14 font-bold mt-4">{{ $t('feide_logout_description') }}</p>

                <div class="flex justify-center mt-8 mb-4">
                    <XCheckbox
                        @input="handleCheck"
                        :checked="logoutAllServices"
                        :square="true"
                        id="logout-checkbox"
                        type="checkbox"
                        name="contact"
                        class="column-gap-16 contact-input-box font-size-14"
                        size="md"
                        theme="red"
                    >
                        {{ $t('feide_logout_logout_all_services') }}
                    </XCheckbox>
                </div>
            </div>
            <div class="popup-footer">
                <XButton @click="logout()" class="logout-button w-full">
                    {{ $t('feide_logout_logout_button') }}
                </XButton>
            </div>
        </div>
    </div>
</template>

<script>
import appConfig from '@/app.config'
import UserService from '@/lib/user'
import XCheckbox from '@/components/v2/XCheckbox'
import XButton from '@/components/v2/XButton'
import { nuxtUrl } from '@/lib/nuxt-url.js'

export default {
    components: {
        XCheckbox,
        XButton
    },

    data() {
        return {
            logoutAllServices: false,
            popup: null
        }
    },

    methods: {
        closePopup() {
            this.$store.commit('setShowLogoutPopup', false)
        },

        handleCheck(event) {
            this.logoutAllServices = event.target.checked
        },

        logout() {
            const userService = new UserService()

            userService.removeToken()

            if (this.logoutAllServices) {
                this.openLogoutPopup()
            }

            this.redirectToMain()
        },

        openLogoutPopup() {
            const screenWidth = window.screen.width
            const screenHeight = window.screen.height

            const left = screenWidth / 2 - 650 / 2
            const top = screenHeight / 2 - 700 / 2

            const options = `scrollbars=no, resizable=no, status=no, location=no, toolbar=no,menubar=no, width=650, height=700, left=${left}, top=${top}`

            window.open(`${appConfig.baseUrl}3rd-party-login/feide/logout`, '3rdlogoutpopup', options)
        },

        redirectToMain() {
            setTimeout(() => {
                location.href = nuxtUrl('/skoler')
            }, 800)
        }
    }
}
</script>

<style lang="scss">
#logout-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;

    .backdrop {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        background-color: #0006;
        z-index: -1;
    }

    .popup-content {
        display: flex;
        flex-direction: column;
        width: 360px;
        height: auto;
        border-radius: 6px;
        color: #333;
        background-color: #fff;

        .popup-header {
            padding: 14px 14px 0 14px;

            h1 {
                margin: 0;
                font-size: 17.5px;
            }

            .close-button {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                color: #6c757d;
                transition: color 0.2s, background-color 0.2s;

                &:hover {
                    color: #343a40;
                    background: #e9ecef;
                }
            }
        }

        .popup-body {
            padding: 14px;

            .warning-icon-box {
                width: 42px;
                height: 42px;
                border: 4px solid red;
                border-radius: 50%;

                i {
                    color: red;
                }
            }

            #logout-checkbox {
                &:checked + .check-box {
                    background-color: var(--button-background-color);
                    border-color: var(--button-background-color);

                    .checkmark {
                        border-bottom-color: var(--button-text-primary-color);
                        border-right-color: var(--button-text-primary-color);
                    }
                }

                + .check-box {
                    width: 22px;
                    height: 22px;
                    border-width: 2px;
                    border-color: #ced4da;
                    border-radius: 6px !important;

                    .checkmark {
                        top: 2px;
                        left: 6px;
                        height: 11px;
                        width: 6px;
                    }
                }
            }
        }

        .popup-footer {
            padding: 0 14px 14px 14px;

            .logout-button {
                border-radius: 6px;
                background-color: #ef4444 !important;
                font-size: 14px !important;
            }
        }
    }
}
</style>